const accountEN = {

	comingSoon: "Coming soon",

	referralSubtitle: "Invite other businesses and earn rewards",
	referralBadge: "$15 each",

	groups: {
		business: "Business",
		preferences: "Preferences",
		account: "Account",
		support: "Support",
	},

	roles: {
		owner: "Owner",
		admin: "Manager",
		staff: "Staff",
		customer: "Customer",
	},

	menuHints: {
		billing: "Plan, invoices and referral credits",
		category: "How your business is listed",
		bookings: "Upcoming visits and your history",
		language: "App language",
		notifications: "Email and push alerts",
		security: "Email, phone and password",
		helpandsupport: "Contact us and read the FAQ",
		about: "App version and legal",
	},

	about: {
		appName: "Sin Fila",
		version: "Version",
		legal: "Legal",
	},

	helpAndSupport: {
		title: "Help & Support",
		subtitle: "Answers to the common questions, and a way to reach a human.",
		contactHint: "Send us a message — we usually reply within a day",
		faqHint: "Quick answers about bookings, billing and your shop",
		resourcesHint: "Guides for growing your business on Sin Fila",
		ctaTitle: "Still stuck?",
		ctaText: "Tell us what's happening and we'll take a look with you.",
		ctaButton: "Contact support",
	},

	menu: {
		bookings: "Appointments",
		favorites: "Favourites",
		reviews: "Reviews",
		notifications: "Notifications",
		language: "Language",
		security: "Login & Security",
		privacy: "Privacy Policy",
		terms: "Terms of Service",
		refund: "Refund Policy",
		contact: "Contact",
		helpandsupport: "Help & Support",
		reportsandperfomance: "Reports & Performance",
		marketing: "Marketing",
		category: "Categories",
		referral: "Referral",
		billing: "Billing",
		logout: "Log Out",
		about: "About"
	},


	aboutSinFila: {
		title: "About Sin Fila",
		tagline: "A Dominican company, built for Dominican businesses.",
		intro: "Sin Fila was created with one mission: to help Dominican businesses modernize the way they manage appointments and grow. We are proudly registered in the Dominican Republic and committed to supporting local entrepreneurs with technology designed around the realities of doing business here.",
		vision: "Our vision is to become the trusted technology partner for thousands of Dominican businesses—helping them grow, serve more customers, and embrace the future with confidence.",
		learnMore: "Learn more about our story",
		flag: "Proudly built and registered in the Dominican Republic.",
	},

	header: {
		title: "Account",
		back: "Back",
	},

	emptyState: {
		title: "Your Account",
		description: "Select an option from the menu to view your appointments, favourites or settings.",
	},
	
	language: {
        title: "Language",
        subtitle: "Choose the language you'd like to use across the app.",
        current: "Current language",
        englishHint: "English",
        spanishHint: "Spanish",
    },

	bookings: {
		title: "Appointments",
		subtitle: "Your next visit, everything still to come, and where you've been.",
		subtitleUpcoming: (count) => `${count} upcoming`,
		nextUp: "Next up",
		noUpcoming: "No upcoming appointments",
		noOtherUpcoming: "Nothing else booked after this one",
		noHistory: "No past visits yet",
		signedOut: "Sign in to see your appointments.",
		historyTitle: "History",
		cancel: "Cancel",
		reschedule: "Reschedule",
		review: "Review",
		confirmed: "confirmed",
		cancelled: "cancelled",
		status: {
			confirmed: "Confirmed",
			cancelled: "Cancelled",
			completed: "Completed",
			in_progress: "In Progress",
			pending: "Pending",
			no_show: "No show",
			rescheduled: "Rescheduled",
		},
		addToCalendar: "Add to Calendar",
		emailSent: "Email sent",
		confirmCancelTitle: "Cancel Booking",
		confirmCancelText: "Are you sure you want to cancel this booking? This action cannot be undone.",
		confirmCancelNo: "Keep Booking",
		confirmCancelYes: "Yes, Cancel",
	},

	favorites: {
		title: "Favourites",
		subtitle: "Shops you've saved for later.",
		empty: "You haven’t added any favourites yet.",
		explore: "Explore shops",
	},

	reviews: {
		title: "My Reviews",
		subtitle: "Everything you've written about the shops you've visited.",
		empty: "You haven’t written any reviews yet.",
		rating: "Rating",
	},

	settings: {
		title: "Account & Settings",
		comingSoon: "Settings will be available soon.",
	},

	status: {
		confirmed: "Confirmed",
		cancelled: "Cancelled",
		pending: "Pending",
	},

	categories: {
		title: "Business Category",
		subtitle: "This is how customers find you when they browse.",
		category: "Category",
		subCategory: "Sub-category",
		select: "Select",
		current: "Currently listed as",
		notSet: "Not set yet",
		save: "Save",
		saving: "Saving…",
		saved: "Category updated",
		error: "We couldn't update your category. Please try again.",
	},

	notifications: {
        title: "Notifications",
        subtitle: "Choose what we send you, and where it lands.",
		emailLabel: "Email",
        pushLabel: "Push",
    
        sections: {
            bookings: "Bookings",
            reviews: "Reviews",
            reminders: "Reminders",
            shop: "Shop",
            staff: "Team",
        },
    
        items: {
            bookings: "New bookings",
            reschedule: "Rescheduled bookings",
            cancellation: "Cancelled bookings",
            reminder24h: "24 hours before booking",
            reminder1h: "1 hour before booking",
            reviews: "New reviews",
            shopBookings: "New bookings for my staff",
            shopUpdates: "Shop updates & announcements",
            role_update: "Role changes",
        },
    
        push: "Push Notifications",
        pushEnabled: "Push notifications are enabled on this device.",
        pushCtaTitle: "Enable push notifications",
        pushCtaHint: "Get real-time alerts on your phone.",
    },
	referral: {
        title: "Referral Program",

		statusLabels: {
            pending_billing: "Awaiting first payment",
            pending_referrer_payment: "Awaiting referrer's payment",
            reward_issued: "Discount applied ✓",
        },

        hero: {
            title: "Save $15 USD per referral",
            subtitle: "Invite other businesses to Sin Fila. Each active referral gives you $15 USD off your next bill.",
            earned: (amount) => `You’ve saved $${amount} so far`,
        },

        code: {
            label: "Your referral code",
            copy: "Copy code",
        },

        link: {
            label: "Share your link",
            copy: "Copy link",
        },

        hint: "Discounts are applied automatically once the referred shop activates billing.",

        faqLink: "Questions about how it works? See the full FAQ",

        stats: {
            active: "Active",
            pending: "Pending",
            saved: "Saved",
        },

        steps: {
            title: "How it works",
            one: { title: "Share your code", text: "Send your code or link to another business owner." },
            two: { title: "They sign up", text: "They list their shop on Sin Fila using your code." },
            three: { title: "You save $15", text: "Once they activate billing, the discount lands on your next invoice." },
        },

        received: {
            title: "Referral you used",
            empty: "You haven't used a referral code yet",
        },

        history: {
            title: "Shops you referred",
            empty: "No referrals yet",
            emptyHint: "Share your code above to get started.",
            pending: "Pending",
            active: "Active",
            rewarded: "Rewarded",
        },
    },

	faq: {
		title: "Frequently Asked Questions",
		sectionLabel: "Referral Program",
		items: [
			{
				question: "How does the Sin Fila Referral Program work?",
				answer:
					"Every new business gets 14 days free when they join Sin Fila. When you refer someone using your unique code, that turns into something better for both of you.",
			},
			{
				question: "What do I get if I refer a business?",
				answer:
					"Once the business you referred makes their first payment, you get a $15 USD reward. There's no limit — refer as many businesses as you like, and earn $15 USD for each one. Your reward is applied automatically to your account.",
			},
			{
				question: "What does my referral get?",
				answer:
					"If you were referred, you get 2 extra weeks free — 28 days total instead of 14 — so you have more time to try Sin Fila before you're charged anything.",
			},
			{
				question: "How do I refer someone?",
				answer: "",
				list: [
					"Find your referral code in your account.",
					"Share it with a business owner you know.",
					"They enter it when they sign up (or within their first 14 days).",
					"Once they make their first payment, your $15 USD reward is added to your account.",
				],
			},
			{
				question: "When is my reward credited?",
				answer: "Rewards are credited only after your referral makes their first payment.",
			},
			{
				question: "What if my reward is bigger than my next bill?",
				answer: "The extra balance carries over to future bills automatically.",
			},
			{
				question: "How long do my referral rewards stay valid?",
				answer: "If you haven't yet subscribed yourself, any rewards you've earned stay valid for 6 months.",
			},
		],
	},

	contact: {
		title: "Contact Support",
		subtitle: "Tell us what's going on and we'll get back to you by email.",
		responseNote: "We usually reply within one business day.",
		email: "Email",
		phone: "Phone (optional)",
		subject: "Subject",
		message: "Message",
		messagePlaceholder: "Your message...",
		send: "Send message",
		sending: "Sending...",
		success: "Message sent successfully",
		errorRequired: "Message is required",
		errorFailed: "Failed to send message",
	},
	
	security: {
		title: "Login And Security",
		subtitle: "Manage how you sign in and how we reach you.",
		dangerZone: "Danger zone",

		emailTitle: "Email",
		emailHint: "The address you use to sign in.",
		passwordTitle: "Reset Password",

		phoneTitle: "Phone Number",
		phoneHint: "Used for booking notifications and account recovery.",
		phoneSave: "Save",
		phoneSaving: "Saving...",
		phoneSuccess: "Phone number updated",
		phoneError: "Could not update phone number",

		comingSoon: "Security settings will be available soon.",
	},

	forgotPassword: {
		subtitle: "We’ll send you an email with instructions to reset your password.",
	
		send: "Send reset link",
		sending: "Sending...",
	
		success: "Password reset email sent successfully.",
	
		toast: {
			error: "Failed to send reset email. Please try again."
		}
	},
};

export default accountEN;
